import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api';
import { useNavigate } from 'react-router-dom';

const BankReceivedList = () => {
    const [entries, setEntries] = useState([]);
    const [filteredEntries, setFilteredEntries] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}bankreceived`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 1) {
                    setEntries(data.data);
                    setFilteredEntries(data.data);
                }
            })
            .catch((error) => console.error('Error fetching bank received entries:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);

        const filtered = entries.filter((entry) =>
            entry.description.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredEntries(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditBankReceived/${id}`);
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this entry?")) {
            fetch(`${BASE_URL}bankreceived/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.status === 1) {
                        // Remove the deleted entry from the state
                        setEntries(entries.filter((entry) => entry.id !== id));
                        setFilteredEntries(filteredEntries.filter((entry) => entry.id !== id));
                    } else {
                        console.error('Error deleting entry:', data.message);
                    }
                })
                .catch((error) => console.error('Error deleting entry:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <h3>Bank Received List</h3>
            </header>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6"></div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/AddBankReceived')}>Add Entry</button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Search by Description"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Staff ID</th>
                                                <th>Customer ID</th>
                                                <th>Amount</th>
                                                <th>Description</th>
                                                <th>Created At</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredEntries.map((entry) => (
                                                <tr key={entry.id}>
                                                    <td>{entry.staff_id}</td>
                                                    <td>{entry.c_id}</td>
                                                    <td>{entry.amount}</td>
                                                    <td>{entry.description}</td>
                                                    <td>{new Date(entry.created_at).toLocaleString()}</td>
                                                    <td className="text-end">
                                                        <button
                                                            className="btn btn-success"
                                                            onClick={() => handleEdit(entry.id)}
                                                        >
                                                            Edit
                                                        </button>
                                                        <button
                                                            className="btn btn-danger ms-2"
                                                            onClick={() => handleDelete(entry.id)}
                                                        >
                                                            Delete
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default BankReceivedList;
